class PriceRange extends HTMLElement {
  connectedCallback() {
    this.minInput = this.querySelector('[data-range-input="min"]');
    this.maxInput = this.querySelector('[data-range-input="max"]');
    this.trackFill = this.querySelector('[data-track-fill]');

    this.rangeMin = Number(this.dataset.rangeMin) || 0;
    this.rangeMax = Number(this.dataset.rangeMax) || 100;

    this.minInput.addEventListener('input', this.#onSliderInput);
    this.maxInput.addEventListener('input', this.#onSliderInput);

    this.#updateFill();
    this.#observePriceInputs();
  }

  #onSliderInput = () => {
    let minVal = Number(this.minInput.value);
    let maxVal = Number(this.maxInput.value);

    if (minVal > maxVal) {
      [minVal, maxVal] = [maxVal, minVal];
      this.minInput.value = minVal;
      this.maxInput.value = maxVal;
    }

    this.#updateFill();
    this.#syncToPriceInputs(minVal, maxVal);
  };

  #updateFill() {
    const min = Number(this.minInput.value);
    const max = Number(this.maxInput.value);
    const range = this.rangeMax - this.rangeMin;
    const left = ((min - this.rangeMin) / range) * 100;
    const right = ((max - this.rangeMin) / range) * 100;
    this.trackFill.style.left = `${left}%`;
    this.trackFill.style.width = `${right - left}%`;
  }

  #syncToPriceInputs(minVal, maxVal) {
    const container = this.closest('.px-5');
    if (!container) return;

    const minPrice = container.querySelector('[data-price-input="min"]');
    const maxPrice = container.querySelector('[data-price-input="max"]');

    if (minPrice) {
      minPrice.value = minVal === this.rangeMin ? '' : minVal;
      minPrice.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (maxPrice) {
      maxPrice.value = maxVal === this.rangeMax ? '' : maxVal;
      maxPrice.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  #observePriceInputs() {
    const container = this.closest('.px-5');
    if (!container) return;

    const minPrice = container.querySelector('[data-price-input="min"]');
    const maxPrice = container.querySelector('[data-price-input="max"]');

    const syncFromInputs = () => {
      const minVal = minPrice?.value ? Number(minPrice.value) : this.rangeMin;
      const maxVal = maxPrice?.value ? Number(maxPrice.value) : this.rangeMax;
      this.minInput.value = minVal;
      this.maxInput.value = maxVal;
      this.#updateFill();
    };

    minPrice?.addEventListener('change', syncFromInputs);
    maxPrice?.addEventListener('change', syncFromInputs);
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}
